function _instanceof(left, right) {
    "@swc/helpers - instanceof";
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { prepareWithSegments, layoutWithLines } from "@chenglou/pretext";
/**
 * Strips HTML and "un-escapes" escape characters.
 * @param {String} input
 */ function htmlDecode(input) {
    if (input.replace(/\s+/g, "") === "") return input;
    var doc = new DOMParser().parseFromString(input.replace(/<[^>]+>/g, ""), "text/html");
    return doc.documentElement ? doc.documentElement.textContent : input;
}
/**
 * Builds a CSS font shorthand string from a style object.
 * @param {Object} styleObj
 */ function buildFont(styleObj) {
    var style = styleObj["font-style"] || "normal";
    var variant = styleObj["font-variant"] || "normal";
    var weight = styleObj["font-weight"] || 400;
    var size = typeof styleObj["font-size"] === "string" ? styleObj["font-size"] : "".concat(styleObj["font-size"] || 10, "px");
    var family = styleObj["font-family"] || "sans-serif";
    return "".concat(style, " ").concat(variant, " ").concat(weight, " ").concat(size, " ").concat(family);
}
/**
 * Measures the width of a single text string using pretext.
 * @param {String} text
 * @param {String} font CSS font shorthand
 */ function measureWidth(text, font) {
    if (!text) return 0;
    var prepared = prepareWithSegments(text, font);
    var result = layoutWithLines(prepared, Infinity, 20);
    return result.lines.length ? result.lines[0].width : 0;
}
export default function(text) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var font = buildFont(style);
    if (_instanceof(text, Array)) return text.map(function(t) {
        return measureWidth(htmlDecode(t), font);
    });
    return measureWidth(htmlDecode(text), font);
}

//# sourceMappingURL=textWidth.js.map